import styled, { css } from 'styled-components';
import { widgetNavIsHidden } from '../../../helpers/widget';

export default {
  NavWrapper: styled.div<{
    schemeMode: boolean;
  }>`
    ${({ schemeMode }) =>
      schemeMode
        ? css`
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;

            @media screen and (max-width: 700px) {
              z-index: 15;
            }
          `
        : css`
            position: relative;
            width: 100%;
            z-index: 999;
            padding-bottom: 8px;
            background-color: #fff;
          `}
  `,
  Nav: styled.div<{
    isFullscreen: boolean;
    isPeriodical: boolean;
  }>`
    box-sizing: border-box;
    display: ${(props) => (widgetNavIsHidden(props) ? 'none' : 'block')};
    position: relative;
    padding: ${(props) => (widgetNavIsHidden(props) ? '0 24px' : '0 62px 0 24px')};
    background: #fff;
    color: rgba(0, 0, 0, 0.64);
    width: 100%;
    z-index: 999;

    ${(props) =>
      props.theme.isMobile &&
      css`
        max-width: 100vw;
      `}

    ${(props) =>
      props.theme.isRtl &&
      css`
        padding: ${(prps) => (widgetNavIsHidden(prps) ? '0 24px' : '0 24px 0 62px')};
      `}

    ${(props) =>
      props.isPeriodical &&
      `
      @media screen and (max-width: 700px) {
        padding: 0 32px;
      }
    `}
  `,

  Container: styled.div<{ isPeriodical: boolean }>`
    width: auto;
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 700px) {
      width: initial;
      flex-direction: column;
      align-items: ${(props) => (props.isPeriodical ? 'center' : 'flex-start')};
      justify-content: center;
      text-align: ${(props) => (props.isPeriodical ? 'center' : 'left')};

      ${(props) =>
        props.theme.isRtl &&
        css`
          text-align: right;
        `}
    }
  `,

  WidthHelper: styled.div`
    width: initial;
    display: flex;
    margin-right: 16px;

    @media screen and (max-width: 700px) {
      width: 100%;
      margin-right: 0;
    }
  `,

  NameWrapper: styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  `,

  Name: styled.span<{ inline?: boolean }>`
    font-weight: bold;
    font-size: 20px;
    color: #000;

    @media screen and (max-width: 700px) {
      margin-right: 16px;
      font-size: 16px;
    }

    ${(props) =>
      props.inline &&
      css`
        @media screen and (max-width: 700px) {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 100%;
          box-sizing: border-box;
        }
      `}
  `,

  Date: styled.span<{ mobile?: boolean }>`
    margin-left: 16px;
    font-size: 18px;
    display: ${({ mobile }) => (mobile ? 'none' : 'initial')};

    @media screen and (max-width: 700px) {
      display: ${({ mobile }) => (mobile ? 'block' : 'none')};
      margin-left: 0;
      margin-bottom: 4px;
      font-size: 14px;
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        margin-left: unset;
        margin-right: 16px;

        @media screen and (max-width: 700px) {
          margin-left: unset;
          margin-right: 0;
        }
      `}
  `,

  Place: styled.div<{ inline?: boolean }>`
    width: initial;
    font-size: 16px;

    white-space: initial;
    overflow: initial;
    text-overflow: initial;

    ${(props) =>
      props.inline &&
      css`
        display: inline-block;
        vertical-align: middle;
        margin-left: 16px;
        margin-right: auto;

        @media screen and (max-width: 700px) {
          display: block;
          text-align: center;
          margin: 0;
        }
      `}

    @media screen and (max-width: 700px) {
      width: 100%;
      font-size: 14px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
};
